var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{staticClass:"navlink",class:_vm.isExect,attrs:{"link":""},on:{"click":[function($event){$event.stopPropagation();return _vm.goto.apply(null, arguments)},function($event){_vm.action?_vm.action():''}]}},[_c('v-list-item-icon',[_c('v-icon',[_vm._v(_vm._s(_vm.icon))])],1),_c('v-list-item-title',[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }